/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import React from 'react';
import { Link } from 'react-router-dom';

function CommercialQuoteInfo({ commercialQuote, setShowGreeniaAI }) {
    return (
        <div className="w-75 ms-auto mb-3">
            <div className="bg-success border border-success p-3 rounded-3 shadow">
                <h5 className="fs-6 text-white">Nuovo Preventivo Commerciale</h5>
                <hr />
                <div>
                    <div>
                        <div className="row">
                            <div className="col-12">
                                <p className="m-0 text-white">
                                    <small>
                                        <strong>
                                            Partita IVA:
                                        </strong>
                                        {' '}
                                        {commercialQuote?.quote?.vat_number}
                                    </small>
                                </p>
                            </div>
                            <div className="col-12">
                                <p className="m-0 text-white">
                                    <small>
                                        <strong>
                                            Dipendenti:
                                        </strong>
                                        {' '}
                                        {commercialQuote?.quote?.number_employees}
                                    </small>
                                </p>
                            </div>
                            <div className="col-12">
                                <p className="m-0 text-white">
                                    <small>
                                        <strong>
                                            Fatturato:
                                        </strong>
                                        {' '}
                                        {commercialQuote?.quote?.max_billed}
                                    </small>
                                </p>
                            </div>
                            {commercialQuote?.quote?.risks?.map((risk, index) => (
                                <div className="col-12" key={index}>
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                {risk?.name}
                                                :
                                            </strong>
                                            {' '}
                                            {risk?.amount}
                                            {' '}
                                            €
                                        </small>
                                    </p>
                                </div>
                            ))}
                        </div>
                        <hr />
                        <div className="row mt-2">
                            <div className="col-12">
                                <Link
                                    onClick={() => setShowGreeniaAI(false)}
                                    className="btn btn-light"
                                    to={`/quote/commercial/${commercialQuote?.quote?.vat_number}/report`}
                                >
                                    Procedi con il Preventivo
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CommercialQuoteInfo;
